import { atom } from 'recoil'

export const bannerMailupShieldState = atom({
  key: 'messages__bannerMailupShieldState',
  default: {
    show: true
  }
})

export const bannerBrandShieldState = atom({
  key: 'messages__bannerBrandShieldState',
  default: {
    show: true
  }
})

export const modalMailupShieldState = atom({
  key: 'messages__modalMailupShieldState',
  default: {
    show: false
  }
})

export const modalBrandShieldState = atom({
  key: 'messages__modalBrandShieldState',
  default: {
    show: false
  }
})

export const deliverabilityIndexState = atom({
  key: 'messages_bannerMailupShield_deliverabilityIndexState',
  default: {
    loaded: false,
    loading: false,
    AlertsData: {
      Sender: false
    }
  }
})
